import { CapoPlugin } from "/app/node_modules/.pnpm/@unhead+vue@1.11.7_vue@3.5.11_typescript@5.6.2_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];